import type { CorrectValue } from 'app/types/tsHelpers';

export class LocalStorageManager<ValueType extends CorrectValue> {
  constructor(private key: string) {
  }

  hasLocalStorage = () => {
    if (localStorage) {
      return true;
    }

    console.error(`localStorage is ${localStorage}`);

    return false;
  };

  public set = (value: ValueType) => {
    if (!this.hasLocalStorage() || value === undefined || Number.isNaN(value)) {
      console.error(`Cannot set ${value} as value`);

      return false;
    }

    localStorage.setItem(this.key, JSON.stringify(value));

    return true;
  };

  public get = (): ValueType | void => {
    const value = this.hasLocalStorage() && localStorage.getItem(this.key);

    if (value) {
      return JSON.parse(value);
    }
  };

  public remove = () => {
    this.hasLocalStorage() && localStorage.removeItem(this.key);
  };
}
